import { partition } from 'ramda'

import { Plan } from '@ecm/data/Plan'

export const filterPlans = (plans: Plan[]) => {
  const [mailRoomPlans, mailboxAndOthers] = partition(
    (p: Plan) => p.businessType === 'highVolume',
    plans
  )

  const [mailBoxPlans] = partition(
    (p: Plan) => p.businessType === 'mailBox' && !['mailbox-a', 'mailbox-b'].includes(p.handle),
    mailboxAndOthers
  )
  return { mailBoxPlans, mailRoomPlans }
}
